module.exports = __webpack_public_path__ + "static/img/ARAD1S_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD1S_1.png
// module id = /rxi
// module chunks = 0